// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.responsive-image[data-v-16c68096] {\n  height: auto;\n  width: auto;\n  max-width: 90%;\n  max-height: 50vh;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
